export const hardCodedKey = 0x69;

export const hexEncode = (cryptoKey: number, text: string) => {
  if (!text) {
    return text;
  }

  let result = '';

  for (let i = 0, hex; i < text.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hex = (text.charCodeAt(i) ^ cryptoKey).toString(16);
    result += `0${hex}`.slice(-2);
  }

  return result;
};

export const hexDecode = (cryptoKey: number, text: string) => {
  if (!text) {
    return text;
  }

  const hexes = text.match(/.{1,2}/g) || [];
  let back = '';

  for (let j = 0; j < hexes.length; j += 1) {
    // eslint-disable-next-line no-bitwise
    back += String.fromCharCode(parseInt(hexes[j], 16) ^ cryptoKey);
  }

  return back;
};

export const buildMessage = (dateText: string) => {
  if (!dateText) {
    return dateText;
  }

  const seconds = Number(dateText.slice(23, 25));
  const message = hexEncode(seconds, dateText);
  const key = hexEncode(hardCodedKey, String.fromCharCode(seconds));

  return `${key}${message}`;
};
